import { apiClient } from '@/lib/api/client'

export interface TaskSlaMetrics {
  total_tasks: number
  breached: number
  within_sla: number
  response_met_rate: number
  resolution_met_rate: number
  avg_resolution_minutes: number
}

export interface TaskAgingBreakdown {
  fresh: number
  aging: number
  old: number
  critical: number
  total_open: number
}

export interface TaskSlaDashboardData {
  sla: TaskSlaMetrics
  aging: TaskAgingBreakdown
}

export type TaskSlaFilters = {
  client_id?: number
  date_from?: string
  date_to?: string
}

export const taskSlaService = {
  async getTaskSla(filters?: TaskSlaFilters): Promise<TaskSlaDashboardData> {
    const res = await apiClient.get<{ data: TaskSlaDashboardData }>('/dashboard/task-sla', {
      params: filters,
    })
    return res.data.data
  },
}
